<section class="splash-hero reveal reveal-pending" #revealSection>
  @if (loading) {
    <app-loader></app-loader>
  }

  <div class="splash-bg" aria-hidden="true">
    <div class="splash-gradient splash-gradient--one"></div>
    <div class="splash-gradient splash-gradient--two"></div>
    <div class="splash-gradient splash-gradient--three"></div>
    <div class="splash-grid"></div>
    <div class="splash-noise"></div>
  </div>

  <div class="splash-content">
    <div class="splash-copy">
      <div class="hero-pill pop-row" #revealItem>
        <span></span>
        Find & Book in Seconds
      </div>

      <h1 class="pop-row" #revealItem>Beauty made effortless.</h1>

      <p class="hero-subtitle pop-row" #revealItem>
        Discover salons, compare services, find availability, and book your next
        hair, beauty, spa, or wellness appointment in just a few taps.
      </p>

      <div class="hero-stats pop-row" #revealItem>
        <div>
          <strong>{{ salons.length || 0 }}+</strong>
          <span>salons listed</span>
        </div>

        <div>
          <strong>24/7</strong>
          <span>online booking</span>
        </div>

        <div>
          <strong>Fast</strong>
          <span>local discovery</span>
        </div>
      </div>

      <div class="hero-search-panel pop-row" #revealItem>
        <div class="search-panel-head">
          <div>
            <h2>Get your glo on</h2>
            <p>Search by service, salon, location, date, or time.</p>
          </div>
        </div>

        <div class="search-panel-fields">
          <div
            class="landing-service-search"
            (click)="$event.stopPropagation()"
          >
            <glo-control
              icon="search"
              placeholder="Service or business"
              classes="bg-gray-50"
              name="serviceSearch"
              [(value)]="serviceQuery"
              (valueChange)="onServiceQueryInput($event)"
            ></glo-control>

            @if (showServiceSuggestions && serviceSuggestions.length) {
              <div class="landing-suggestions">
                @for (
                  suggestion of serviceSuggestions;
                  track suggestion.kind + suggestion.value
                ) {
                  <button
                    type="button"
                    class="landing-suggestion-item"
                    (click)="selectServiceSuggestion(suggestion)"
                  >
                    <div class="landing-suggestion-item__main">
                      <div
                        class="landing-suggestion-icon"
                        [class.landing-suggestion-icon--salon]="
                          suggestion.kind === 'salon'
                        "
                        [class.landing-suggestion-icon--service]="
                          suggestion.kind === 'service'
                        "
                        [class.landing-suggestion-icon--type]="
                          suggestion.kind === 'type'
                        "
                      >
                        @switch (suggestion.kind) {
                          @case ("salon") {
                            <span>⌂</span>
                          }

                          @case ("service") {
                            <span>✦</span>
                          }

                          @case ("type") {
                            <span>◆</span>
                          }

                          @default {
                            <span>#</span>
                          }
                        }
                      </div>

                      <span>
                        {{ suggestion.label }}
                      </span>
                    </div>

                    <span class="landing-suggestion-kind">
                      {{ suggestion.kind }}
                    </span>
                  </button>
                }
              </div>
            }
          </div>

          <app-google-address
            name="locationSearch"
            label=""
            placeholder="City or location"
            [(ngModel)]="locationQuery"
            (placeSelected)="onLocationPlaceSelected($event)"
          >
          </app-google-address>

          <!-- Cost -->
          <glo-control
            type="select"
            name="costSearch"
            [options]="costOptions"
            [showKey]="'name'"
            [valueKey]="'id'"
            [placeholder]="'Any price'"
            [(value)]="selectedCost"
            classes="bg-gray-50"
          ></glo-control>

          <div class="date-timerange-control">
            <glo-date-control
              class="flex flex-1"
              (dateChange)="onSearchDateChange($event)"
            ></glo-date-control>

            <glo-timepicker
              (timeChange)="onSearchTimeChange($event)"
            ></glo-timepicker>
          </div>
        </div>

        <button type="button" class="primary-cta" (click)="searchSalons()">
          Discover now
        </button>
      </div>
    </div>

    <div class="salon-stage hero-photo-reels" aria-hidden="true">
      <div class="hero-photo-reels__glow hero-photo-reels__glow--one"></div>
      <div class="hero-photo-reels__glow hero-photo-reels__glow--two"></div>

      <div class="hero-photo-reels__window">
        <!-- LEFT COLUMN - scrolls DOWN -->
        <div class="hero-photo-column hero-photo-column--down">
          <div class="hero-photo-track hero-photo-track--down">
            <div
              class="hero-photo-card"
              *ngFor="
                let photo of heroReelLeftSet;
                trackBy: trackByHeroReelPhoto
              "
            >
              <img [src]="assetUrl + photo" alt="" />
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN - scrolls UP -->
        <div class="hero-photo-column hero-photo-column--up">
          <div class="hero-photo-track hero-photo-track--up">
            <div
              class="hero-photo-card"
              *ngFor="
                let photo of heroReelRightSet;
                trackBy: trackByHeroReelPhoto
              "
            >
              <img [src]="assetUrl + photo" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section
  class="landing-section landing-section-shell reveal reveal-pending"
  #revealSection
>
  <div class="section-heading section-heading--center pop-row" #revealItem>
    <span class="section-kicker">Start faster</span>
    <h2>Not sure what to book?</h2>
    <p>
      Pick a quick path and jump straight into salons, services, offers, and
      appointment times that match what you need.
    </p>
  </div>

  <div class="discovery-grid">
    <button
      type="button"
      class="discovery-card pop-row"
      #revealItem
      (click)="searchNearMe()"
    >
      <img [src]="assetUrl + 'icons/map-tag.svg'" alt="" />
      <div>
        <strong>Near me</strong>
        <span>Find salons around your area.</span>
      </div>
    </button>

    <button
      type="button"
      class="discovery-card pop-row"
      #revealItem
      (click)="quickSearch('top rated', '')"
    >
      <img [src]="assetUrl + 'icons/magic.svg'" alt="" />
      <div>
        <strong>Top Rated</strong>
        <span>Book highly reviewed places.</span>
      </div>
    </button>

    <button
      type="button"
      class="discovery-card pop-row"
      #revealItem
      (click)="quickSearch('budget friendly', '')"
    >
      <img [src]="assetUrl + 'icons/budget.svg'" alt="" />
      <div>
        <strong>Budget-Friendly</strong>
        <span>Browse great value services.</span>
      </div>
    </button>

    <button
      type="button"
      class="discovery-card pop-row"
      #revealItem
      (click)="quickSearch('specials', '')"
    >
      <img [src]="assetUrl + 'icons/special-promo.svg'" alt="" />
      <div>
        <strong>Special Promos</strong>
        <span>Explore offers and deals.</span>
      </div>
    </button>
  </div>
</section>

<section
  class="landing-section landing-section-shell feature-splash reveal reveal-pending"
  #revealSection
>
  <div class="feature-copy pop-row" #revealItem>
    <span class="section-kicker">Why customers use gloget</span>
    <h2>Book confidently without calling around.</h2>
    <p>
      Search locally, compare options, check availability, and book with a clean
      experience that feels fast from start to finish.
    </p>
  </div>

  <div class="feature-grid">
    <article class="feature-card pop-row" #revealItem>
      <span>01</span>
      <strong>Search locally</strong>
      <p>Find nearby salons based on service, location, and availability.</p>
    </article>

    <article class="feature-card pop-row" #revealItem>
      <span>02</span>
      <strong>Book quickly</strong>
      <p>
        Choose a time without calling, waiting, or messaging back and forth.
      </p>
    </article>

    <article class="feature-card pop-row" #revealItem>
      <span>03</span>
      <strong>Discover more</strong>
      <p>Explore new treatments, offers, and salons you may not know yet.</p>
    </article>
  </div>
</section>

<section
  class="landing-section landing-section-shell overflow-hidden reveal reveal-pending"
  #revealSection
>
  <div class="section-heading pop-row" #revealItem>
    <span class="section-kicker">Top picks</span>
    <h2>Looking for the best salon in Toronto?</h2>
    <p>
      Discover top salons, must-try treatments, and the best beauty deals near
      you.
    </p>
  </div>

  <div class="carousel-shell pop-row" #revealItem>
    @if (loading) {
      <div class="skeleton-row">
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
      </div>
    } @else if (salons.length === 0) {
      <glo-empty mode="salons" [showBtn]="true"></glo-empty>
    } @else {
      <glo-carousel-arrow class="w-full">
        <glo-card-landing
          *ngFor="let salon of salons; trackBy: trackBySalonId"
          #carouselSlide
          (afterToggle)="handleToggle($event)"
          (onLoad)="onLoad($event)"
          [hasLeftIcon]="true"
          [salon]="salon"
        ></glo-card-landing>
      </glo-carousel-arrow>
    }
  </div>
</section>

<section
  class="landing-section landing-section-shell overflow-hidden reveal reveal-pending"
  #revealSection
>
  <div class="section-heading pop-row" #revealItem>
    <span class="section-kicker">Fresh arrivals</span>
    <h2 class="logo-title">
      New to
      <img [src]="assetUrl + 'icons/gloget_logo-trans.png'" alt="gloget" />
    </h2>
    <p>
      Step into something new with gloget's recently added salons and services.
    </p>
  </div>

  <div class="carousel-shell pop-row" #revealItem>
    @if (loading) {
      <div class="skeleton-row">
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
      </div>
    } @else if (salons.length === 0) {
      <glo-empty mode="salons" [showBtn]="true"></glo-empty>
    } @else {
      <glo-carousel-arrow class="w-full">
        <glo-card-landing
          *ngFor="let salon of salons; trackBy: trackBySalonId"
          #carouselSlide
          (afterToggle)="handleToggle($event)"
          (onLoad)="onLoad($event)"
          [hasLeftIcon]="false"
          [salon]="salon"
        ></glo-card-landing>
      </glo-carousel-arrow>
    }
  </div>
</section>

<section
  class="landing-section landing-section-shell overflow-hidden reveal reveal-pending"
  #revealSection
>
  <div class="section-heading pop-row" #revealItem>
    <span class="section-kicker">Same-day booking</span>
    <h2>Available Now</h2>
    <p>Need it now? These salons and services are available today.</p>
  </div>

  <div class="carousel-shell pop-row" #revealItem>
    @if (loading) {
      <div class="skeleton-row">
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
        <app-card-skeleton></app-card-skeleton>
      </div>
    } @else if (salons.length === 0) {
      <glo-empty mode="salons" [showBtn]="true"></glo-empty>
    } @else {
      <glo-carousel-arrow class="w-full">
        <glo-card-landing
          *ngFor="let salon of salons; trackBy: trackBySalonId"
          #carouselSlide
          (afterToggle)="handleToggle($event)"
          (onLoad)="onLoad($event)"
          [hasLeftIcon]="false"
          [salon]="salon"
        ></glo-card-landing>
      </glo-carousel-arrow>
    }
  </div>
</section>

<section
  class="landing-section landing-section-shell reveal reveal-pending"
  #revealSection
>
  <glo-carousel>
    <div #carouselSlide class="keen-slider__slide flex justify-center">
      <div class="testimonial-card pop-row" #revealItem>
        <div class="testimonial-image">
          <img [src]="assetUrl + 'img/customer-photo.png'" alt="" />
        </div>

        <div class="testimonial-copy">
          <img [src]="assetUrl + 'icons/5stars.svg'" alt="" />
          <h3>
            “I found a salon and booked my appointment in minutes. The whole
            experience felt easy.”
          </h3>
          <p>— John Doe</p>
          <span>Customer</span>
        </div>
      </div>
    </div>

    <div #carouselSlide class="keen-slider__slide flex justify-center">
      <div class="testimonial-card pop-row" #revealItem>
        <div class="testimonial-image">
          <img [src]="assetUrl + 'img/customer-photo.png'" alt="" />
        </div>

        <div class="testimonial-copy">
          <img [src]="assetUrl + 'icons/5stars.svg'" alt="" />
          <h3>“The booking flow feels clean, fast, and simple.”</h3>
          <p>— Olivia R.</p>
          <span>Customer</span>
        </div>
      </div>
    </div>
  </glo-carousel>
</section>

<section
  class="landing-section landing-section-shell reveal reveal-pending"
  #revealSection
>
  <div class="pop-row" #revealItem>
    <landing-our-blog></landing-our-blog>
  </div>
</section>

<section
  class="landing-section landing-section-shell reveal reveal-pending"
  #revealSection
>
  <div class="final-cta pop-row" #revealItem>
    <div class="final-cta-left">
      <span class="section-kicker">For customers</span>
      <h2>Start booking, start saving.</h2>
      <p>
        Book in seconds, discover better options, and keep your beauty routine
        moving.
      </p>

      <button
        type="button"
        class="primary-cta primary-cta--inline"
        (click)="searchSalons()"
      >
        Find salons now
      </button>
    </div>

    <div class="final-cta-right">
      <span class="section-kicker">For salons</span>
      <h2>Grow your business with us.</h2>
      <p>
        Book a demo and unlock an easier way to attract, schedule, and manage
        clients.
      </p>

      <form
        class="demo-form"
        (ngSubmit)="submitDemoRequest()"
        #demoForm="ngForm"
      >
        <label>
          <span>Name</span>
          <input
            type="text"
            name="fullname"
            id="fullname"
            placeholder="Insert your full name"
            [(ngModel)]="demoRequest.name"
            required
            minlength="2"
            maxlength="150"
            [disabled]="demoSubmitting"
          />
        </label>

        <label>
          <span>Email</span>
          <input
            type="email"
            name="email"
            id="email"
            placeholder="olivia@example.com"
            [(ngModel)]="demoRequest.email"
            required
            email
            maxlength="254"
            [disabled]="demoSubmitting"
          />
        </label>

        @if (demoSuccess) {
          <p class="demo-message demo-message--success" role="status">
            Thank you! Your demo request has been received.
          </p>
        }

        @if (demoError) {
          <p class="demo-message demo-message--error" role="alert">
            {{ demoError }}
          </p>
        }

        <button
          type="submit"
          class="primary-cta"
          [disabled]="demoSubmitting || demoForm.invalid"
        >
          {{ demoSubmitting ? "Sending request..." : "Schedule a demo" }}
        </button>
      </form>
    </div>
  </div>
</section>
